export const popUpURL = document.location.origin.replace(/\/$/, '');
